<template>
  <v-card class="pa-6 reset-card" width="450">

    <v-card-title class="text-h5">INP-Platzbuchung</v-card-title>
    <v-card-subtitle class="text-h8" style="color: black; text-decoration: underline;">
      Passwort-Manager
    </v-card-subtitle>

    <!-- ❌ Token ungültig -->
    <v-alert
      v-if="tokenInvalid"
      type="error"
      class="my-4"
      dense
      outlined
    >
      {{ errorMessage || "Der Link ist ungültig oder abgelaufen." }}
    </v-alert>

    <!-- ✅ Erfolg -->
    <v-alert
      v-if="success"
      type="success"
      class="my-4"
      dense
      outlined
    >
      Passwort erfolgreich geändert. Sie werden weitergeleitet...
    </v-alert>

    <v-form @submit.prevent="submit" v-if="!success">

      <v-text-field
        v-model="password"
        label="Neues Passwort"
        prepend-inner-icon="mdi-lock"
        :disabled="tokenInvalid"
        :type="showPassword ? 'text' : 'password'"
        :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append-inner="showPassword = !showPassword"
        required
      />

      <v-text-field
        v-model="passwordConfirm"
        label="Passwort bestätigen"
        prepend-inner-icon="mdi-lock-check"
        :disabled="tokenInvalid"
        :type="showPassword2 ? 'text' : 'password'"
        :append-inner-icon="showPassword2 ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append-inner="showPassword2 = !showPassword2"
        required
      />

      <!-- Fehleranzeige im Formular -->
      <v-alert
        v-if="errorMessage && !tokenInvalid"
        type="error"
        dense
        outlined
        class="my-2"
      >
        {{ errorMessage }}
      </v-alert>

      <v-btn
        block
        color="#FF7500"
        type="submit"
        :disabled="tokenInvalid"
      >
        Passwort setzen
      </v-btn>
    </v-form>

  </v-card>
</template>


<script>
export default {
  data() {
    return {
      uid: null,
      token: null,
      password: "",
      passwordConfirm: "",
      showPassword: false,
      showPassword2: false,

      errorMessage: "",
      tokenInvalid: false,
      success: false,
    };
  },

  mounted() {
    // 🔎 URL-Parameter auslesen
    this.uid = this.$route.query.uid;
    this.token = this.$route.query.token;

    // Wenn die URL keine Daten enthält → invalid
    if (!this.uid || !this.token) {
      this.tokenInvalid = true;
      this.errorMessage = "Ungültiger Passwort-Reset-Link.";
    }
  },

  methods: {
    validatePassword(pw) {
      return pw.length >= 6 && /\d/.test(pw) && /[A-Z]/.test(pw);
    },

    async submit() {
      this.errorMessage = "";

      if (this.password !== this.passwordConfirm) {
        this.errorMessage = "Die Passwörter stimmen nicht überein.";
        return;
      }

      if (!this.validatePassword(this.password)) {
        this.errorMessage =
          "Das Passwort muss mindestens 6 Zeichen lang sein und eine Zahl & einen Großbuchstaben enthalten.";
        return;
      }

      try {
        await this.$axios.post("/api/users/reset-password/confirm/", {
          uid: this.uid,
          token: this.token,
          new_password: this.password,
        });

        this.success = true;

        setTimeout(() => {
          this.$router.push({ name: "Auth" });
        }, 1500);

      } catch (err) {
        this.tokenInvalid = true;
        this.errorMessage =
          err.response?.data?.error ||
          "Ungültiger oder abgelaufener Link.";
      }
    },
  },
};
</script>


<style scoped>
.reset-card {
  border-radius: 32px;
}
</style>
